import {FEDEX} from '../../../common/constants/ShipperNames.js'
import {
  updateLabelConfig,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  attachCustomsInfoSelector,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {getState, useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

export const VALID_TERMS_OF_SALE_SHIPPER_TYPES = [FEDEX]

const TERMS_OF_SALE_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return TERMS_OF_SALE_DEPENDENT_PROPERTIES
}

export function formatTermsOfSaleLabelProperty(shipperType) {
  return `${shipperType}__terms_of_sale`
}

export function termsOfSaleLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo &&
    VALID_TERMS_OF_SALE_SHIPPER_TYPES.includes(shipperType)
    ? [formatTermsOfSaleLabelProperty(shipperType)]
    : []
}

const VALID_TERMS_OF_SALE_LABEL_PROPERTIES =
  VALID_TERMS_OF_SALE_SHIPPER_TYPES.map((shipperType) =>
    formatTermsOfSaleLabelProperty(shipperType),
  )

export default function TermsOfSale() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = TermsOfSale.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="Terms of Sale"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      hide={!attachCustomsInfo}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="terms_of_sale"
    />
  )
}

TermsOfSale.propertySpecList = [
  {
    validShipperTypes: VALID_TERMS_OF_SALE_SHIPPER_TYPES,
    labelPropertiesFunc: termsOfSaleLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_TERMS_OF_SALE_LABEL_PROPERTIES
    },
  },
]
